export default "__VITE_ASSET__ff4_1zwd__"